import { FormControl, FormErrorMessage, FormLabel } from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";

interface BaseFormControlProps {
  name: string;
  label: string;
  children: React.ReactNode;
  isRequired?: boolean;
  isDisabled?: boolean;
  isReadOnly?: boolean;
}

export function BaseFormControl({
  name,
  label,
  children,
  isRequired,
  isDisabled,
  isReadOnly,
}: BaseFormControlProps) {
  const {
    formState: { errors },
  } = useFormContext();

  const fieldError = errors[name];

  return (
    <FormControl
      isInvalid={!!fieldError}
      isRequired={isRequired}
      isDisabled={isDisabled}
      isReadOnly={isReadOnly}
    >
      <FormLabel>{label}</FormLabel>
      {children}
      <FormErrorMessage>{fieldError && fieldError.message?.toString()}</FormErrorMessage>
    </FormControl>
  );
}
